import { render } from "./SpinnerComponent.vue?vue&type=template&id=5f011a5a"
import script from "./SpinnerComponent.vue?vue&type=script&lang=js"
export * from "./SpinnerComponent.vue?vue&type=script&lang=js"

import "./SpinnerComponent.vue?vue&type=style&index=0&id=5f011a5a&lang=css"

import exportComponent from "/home/runner/work/tawa.digital.dashboard/tawa.digital.dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__